import { t } from 'i18next';

export const SHIPPER_PAYABLE_STATUS = {
  ON_HOLD: 'ON HOLD',
  REVIEWED: 'REVIEWED',
};

export const SHIPPER_PAYABLE_COMPLETED_STATUS = {
  FULLY_COMPLETED: 'FULLY COMPLETED',
  PARTIALLY_COMPLETED: 'PARTIALLY COMPLETED',
};

export const SHIPPER_PAYABLE_STATUSES_OPTIONS = [
  {
    label: t('payables:arrived_at_hub'),
    value: 'ARRIVED_AT_HUB',
  },
  {
    label: t('payables:needs_review'),
    value: 'NEEDS_REVIEW',
  },
  {
    label: t('payables:hold'),
    value: 'HOLD',
  },
  {
    label: t('payables:reviewed'),
    value: 'REVIEWED',
  },
  {
    label: t('payables:requested'),
    value: 'REQUESTED',
  },
  {
    label: t('payables:finance_approved'),
    value: 'FINANCE_APPROVED',
  },
  {
    label: t('payables:finance_cancelled'),
    value: 'FINANCE_CANCELLED',
  },
  {
    label: t('payables:finance_on_hold'),
    value: 'FINANCE_ON_HOLD',
  },
  {
    label: t('payables:processing'),
    value: 'PROCESSING',
  },
  {
    label: t('payables:disbursed'),
    value: 'DISBURSED',
  },
  {
    label: t('payables:disbursement_failed'),
    value: 'DISBURSEMENT_FAILED',
  },
];

export const SHIPPER_PAYABLE_STATUSES = {
  ARRIVED_AT_HUB: 'ARRIVED_AT_HUB',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  HOLD: 'HOLD',
  REVIEWED: 'REVIEWED',
  REQUESTED: 'REQUESTED',
  FINANCE_APPROVED: 'FINANCE_APPROVED',
  FINANCE_CANCELLED: 'FINANCE_CANCELLED',
  FINANCE_ON_HOLD: 'FINANCE_ON_HOLD',
  PROCESSING: 'PROCESSING',
  DISBURSED: 'DISBURSED',
  DISBURSEMENT_FAILED: 'DISBURSEMENT_FAILED',
};

export const DUE_STATUSES = {
  NOT_DUE_STATUS: 'NOT_DUE_STATUS',
  UPCOMING: 'UPCOMING',
  OVERDUE: 'OVERDUE',
  COMPLETED: 'COMPLETED',
};

export const DUE_STATUS_COLORS = {
  [DUE_STATUSES.NOT_DUE_STATUS]: 'primary',
  [DUE_STATUSES.UPCOMING]: 'danger',
  [DUE_STATUSES.OVERDUE]: 'orangeyYellow',
  [DUE_STATUSES.COMPLETED]: 'success',
};

export default {};
